var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "py-2", attrs: { cols: "12", sm: "6" } },
        [
          _vm.ocrDocuments.length
            ? _c(
                "v-btn",
                {
                  attrs: {
                    color: "secondary",
                    depressed: "",
                    elevation: "4",
                    raised: "",
                    href: _vm.buildOcrLink(),
                    target: "_blank"
                  }
                },
                [_vm._v("\n      Consultar documentos no CAF\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.backgroundCheckDocuments.length
            ? _c(
                "v-btn",
                {
                  attrs: {
                    color: "secondary",
                    depressed: "",
                    elevation: "4",
                    raised: "",
                    href: _vm.buildBackgroundCheckLink(),
                    target: "_blank"
                  }
                },
                [_vm._v("\n      Consultar antecedentes no CAF\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbb9764a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbb9764a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Register/CombateAFraudeLinks.vue
// module id = null
// module chunks = 